// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2n6xK","calendarButtons":"ClockData_calendarButtons__1ic17"};